import { ConflictError } from "./conflict-error";

// Thrown by the restore guard when the order it names is not cancelled. Restoring writes
// `pending` over every suborder, so aimed at a live order it would discard a picker's progress
// through the round. 409 for the reason OrderNotCancellableError is.
export class OrderNotRestorableError extends ConflictError {
	constructor() {
		super("stock.order_not_restorable");
		this.name = "OrderNotRestorableError";
	}
}
